import { Client } from "../domain/clients";
import { getAllClientsService } from "../infrastructure/services/getAllClientsService";

export const getAllClients = {
  async execute(): Promise<Client[]> {
    return await getAllClientsService.execute();
  },
};


